let APPLICATION_ID
let backendURL
let appAdminBackendURL
let firebaseConfig
let loginURL

let unprotectedToken

let homeURL
const environment = process.env.REACT_APP_ENV

if (process.env.REACT_APP_ENV === "development") {
    APPLICATION_ID = "23"
    backendURL = "http://localhost:5001"
    appAdminBackendURL = "http://localhost:5000"
    loginURL = "http://localhost:3000"
    unprotectedToken = process.env.REACT_APP_UNPROTECTED_TOKEN
    homeURL = "https://mingle35-portal.inforgov.com/PRECIPART_TST/"

    firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
        appId: process.env.REACT_APP_FIREBASE_APPID,
        measurementId: process.env.REACT_APP_FIREBASE_MEASURMENTID
    }
} else if (process.env.REACT_APP_ENV === "gcpdevelopment") {
    APPLICATION_ID = "23"
    backendURL = "https://access-management-server-tdnsdphoqq-uk.a.run.app/"
    appAdminBackendURL =
        "https://application-administration-server-tdnsdphoqq-uk.a.run.app/"
    loginURL =
        "https://application-administration-client-tdnsdphoqq-uk.a.run.app"
    unprotectedToken = process.env.REACT_APP_UNPROTECTED_TOKEN
    homeURL = "https://mingle35-portal.inforgov.com/PRECIPART_TST/"

    firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
        appId: process.env.REACT_APP_FIREBASE_APPID,
        measurementId: process.env.REACT_APP_FIREBASE_MEASURMENTID
    }
} else if (process.env.REACT_APP_ENV === "test") {
    APPLICATION_ID = "7"
    backendURL = "https://access-management-server-b34iv6u2nq-uk.a.run.app/"
    appAdminBackendURL =
        "https://application-administration-server-b34iv6u2nq-uk.a.run.app/"
    loginURL =
        "https://application-administration-client-b34iv6u2nq-uk.a.run.app"
    unprotectedToken = process.env.REACT_APP_UNPROTECTED_TOKEN
    homeURL = "https://mingle35-portal.inforgov.com/PRECIPART_TRN/"

    firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
        appId: process.env.REACT_APP_FIREBASE_APPID,
        measurementId: process.env.REACT_APP_FIREBASE_MEASURMENTID
    }
} else if (process.env.REACT_APP_ENV === "production") {
    APPLICATION_ID = "7"
    backendURL = "https://access-management-server-jaf747essq-uk.a.run.app/"
    appAdminBackendURL =
        "https://application-administration-server-jaf747essq-uk.a.run.app/"
    loginURL =
        "https://application-administration-client-jaf747essq-uk.a.run.app"
    unprotectedToken = process.env.REACT_APP_UNPROTECTED_TOKEN
    homeURL = "https://mingle35-portal.inforgov.com/PRECIPART_PRD/"

    firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
        appId: process.env.REACT_APP_FIREBASE_APPID,
        measurementId: process.env.REACT_APP_FIREBASE_MEASURMENTID
    }
}

export {
    APPLICATION_ID,
    backendURL,
    appAdminBackendURL,
    firebaseConfig,
    loginURL,
    homeURL,
    environment,
    unprotectedToken
}
